<template>
  <section>
    <vx-card title="Recommendation List">
      <vs-list>
        <vs-list-item v-for="(i, index) in data" :key="index" :title="i.titleId" :subtitle="i.subtitleId" class="cursor-pointer" @click.native="$router.push(`/data/recommendation-business/${i.id}`)">
            <vs-avatar
            :src="listItem.logoUrl" v-for="(listItem, index) in i.itemList"
            :key="index" :text="listItem.name" />
        </vs-list-item>
      </vs-list>
    </vx-card>
  </section>
</template>

<script>
import RecommendationBusinessCard from './RecommendationBusinessCard'
import RecommendationBusinessForm from './RecommendationBusinessForm'
export default {
  components: { RecommendationBusinessCard, RecommendationBusinessForm },
  computed: {
    data: {
      get () {
        return this.$store.getters['recommendationBusiness/arrayData']
      }
    }
  },
  data() {
    return {
      showForm: false,
      formData: {
        id: '',
        title: '',
        show: false,
        data: {
          id: '',
          status: '',
          titleId: '',
          titleEn: '',
          subtitleId: '',
          subtitleEn: '',
          itemList: []
        }
      }
    }
  }
}
</script>
